import React from "react";
import { observer } from "mobx-react";
import { WeaInputNumber, WeaTools } from "ecCom";

import toNumber from "lodash/toNumber";
import isNaN from "lodash/isNaN";
import isString from "lodash/isString";
import endsWith from "lodash/endsWith";
const { desensitization, encryption } = WeaTools.EncryBase;

@observer
export default class InputNumberItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  onBlur = value => {
    const { itemKey, onBlur } = this.props;
    if (typeof onBlur === "function") {
      onBlur(itemKey, value);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    // fix 0 不显示
    let v =
      !!bindObj.bind().value && !isNaN(toNumber(bindObj.bind().value))
        ? bindObj.bind().value
        : "";
    // show default value 0
    if (bindObj.bind().value === 0) v = 0;
    // show last decimal point and 0
    if (isString(bindObj.bind().value)) {
      v =
        endsWith(bindObj.bind().value, ".") ||
        endsWith(bindObj.bind().value, "0")
          ? bindObj.bind().value
          : v;
    }

    // fix first '-' disappare
    if (bindObj.bind().value == "-") {
      v = bindObj.bind().value;
    }

    // 加密数据处理
    if (
      desensitization(bindObj.bind().value) ||
      encryption(bindObj.bind().value)
    ) {
      v = bindObj.bind().value;
    }
    return (
      <WeaInputNumber
        ecId={`${this.props.ecId}_WeaInputNumber@4w9pmb`}
        {...bindObj.bind()}
        value={v}
        onChange={this.onChange}
        onBlur={this.onBlur}
        {...c}
        {...c.otherParams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/InputNumberItem.js